import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { clearAccessTokens } from '@ecp/common/src/utils/utils';
import boTheme from '@ecp/common/src/style/theme/bo';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { FlexBox, FlexBoxSpaceBetween } from '@ecp/common/src/layouts/flex/styled';
import { TextButton } from '@ecp/common/src/components/button/TextButton';

import { useConfirmDialog } from '@bo-hooks/common/useModal';
import authApi from '@bo-apis/common/authApi';
import GnbSearch from './GnbSearch';
import UserWrapper from './UserWrapper';
import { isPODomain } from '@bo-const/common/domain';
import GnbAlarm from '@bo-layout/gnb/alarm/GnbAlarm';
import AuthWrapper from '@bo-layout/gnb/AuthWrapper';
import PoPersonalInfoChange from '@bo-layout/po/PoPersonalInfoChange';

const Container = styled(FlexBoxSpaceBetween)`
  width: 100%;
  height: 50px;
  flex-grow: 0;
  flex-shrink: 0;
  border-bottom: 1px solid ${boTheme.color.sub8};
  box-sizing: border-box;
  background-color: ${boTheme.color.sub10};
  min-width: 1160px;
`;

const UtilityWrapper = styled(FlexBox)`
  align-items: center;
`;

const Gnb = () => {
  const navigate = useNavigate();
  const { showConfirmDialog } = useConfirmDialog();

  const logout = async () => {
    await authApi.logout();
    clearAccessTokens();
    if (isPODomain()) {
      navigate('/partner/logout');    
    } else {
      navigate('/logout'); //TODO : TBD
    }
  };

  const handleLogoutBtnClick = () => {
    showConfirmDialog('로그아웃 하시겠습니까?', logout);
  };

  return (
    <Container>
      <GnbSearch />
      <UtilityWrapper>
        <UserWrapper />
        <Spacing left={30} />
        <FlexBox gap={'8px'}>
          <TextButton textProps={{ weight: boTheme.font.weight.regular }} onClick={handleLogoutBtnClick}>
            로그아웃
          </TextButton>
          {isPODomain() ? <PoPersonalInfoChange /> : <AuthWrapper />}
        </FlexBox>
        <Spacing left={50} right={50}>
          <GnbAlarm />
        </Spacing>
      </UtilityWrapper>
    </Container>
  );
};

export default Gnb;
